import RecordBase from './Base';
import i18next from '~/i18n';
import dig from 'object-dig';

export default class CorporationRecord extends RecordBase {
  static defaultAttributes = {
    country: '',
    name: '',
    email: '',
    phone: '',
    cnpj: '',
    street: '',
    district: '',
    number: '',
    postal_code: '',
    contact_name: '',
    contact_phone: '',
    contract_expires_at: '',
    disabled_at: null,
    frozen_at: null,
    city: null,
    is_driving: false,
    is_doctor: false,
    is_doctor_all: false,
    is_plan: false,
    is_emergency: false,
    partner: null,
    users_limit: null,
    corporation: null,
    owners: [],
    specialties: [],
    packs: [],
    branches: [],
    corporation_doctors: [],
    config_corporation: {
      required_cns: true,
      required_location: true,
      required_documents: false,
      has_benefits_club: false,
      required_email: true,
      user_welcome_email: false,
      corporation_type: null,
      wallet_id: '',
      landing_url: '',
      accession_percentage: 0,
      signature_percentage: 0,
      income_value: 0,
    },
  };

  static _attributeNames = null;

  static get attributeNames() {
    const trAttr = (attr) => i18next.t(`corporation.attributes.${attr}`);
    if (!this._attributeNames) {
      this._attributeNames = {
        country: trAttr('country'),
        name: trAttr('name'),
        email: trAttr('email'),
        phone: trAttr('phone'),
        cnpj: trAttr('cnpj'),
        city: trAttr('city'),
        street: trAttr('street'),
        district: trAttr('district'),
        number: trAttr('number'),
        postal_code: trAttr('postal_code'),
        contact_name: trAttr('contact_name'),
        contact_phone: trAttr('contact_phone'),
        contract_expires_at: trAttr('contract_expires_at'),
        is_driving: trAttr('is_driving'),
        is_doctor: trAttr('is_doctor'),
        is_doctor_all: trAttr('is_doctor_all'),
        is_emergency: trAttr('is_emergency'),
        disabled_at: trAttr('disabled_at'),
        users_limit: trAttr('users_limit'),
        is_plan: trAttr('is_plan'),
        frozen_at: trAttr('frozen_at'),
        corporation: trAttr('corporationFather'),
        owners: trAttr('owners'),
        specialties: trAttr('specialties'),
        packPackages: trAttr('packPackages'),
        required_cns: trAttr('required_cns'),
        required_location: trAttr('required_location'),
        required_documents: trAttr('required_documents'),
        has_benefits_club: trAttr('has_benefits_club'),
        required_email: trAttr('required_email'),
        user_welcome_email: trAttr('user_welcome_email'),
        corporation_type: trAttr('corporation_type'),
        branches: trAttr('branches'),
        wallet_id: trAttr('wallet_id'),
        landing_url: trAttr('landing_url'),
        accession_percentage: trAttr('accession_percentage'),
        signature_percentage: trAttr('signature_percentage'),
        income_value: trAttr('income_value'),
      };
    }

    return this._attributeNames;
  }

  // Validações específicas para corporation_type
  validateCorporationFields() {
    const config = this.get('config_corporation') || {};
    const { corporation_type, wallet_id, landing_url, accession_percentage, signature_percentage, income_value } = config;
    const errors = [];
    const isEdit = !!this.get('id'); // Se existe id, é edição

    // Se for franchise ou insurance, validar campos obrigatórios
    if (corporation_type === 'franchise' || corporation_type === 'insurance') {
      if (isEdit && !wallet_id) {
        errors.push('Wallet ID é obrigatório para franquias e seguradoras');
      }

      if (corporation_type === 'franchise') {
        if (!landing_url) {
          errors.push('URL de landing page é obrigatória para franquias e seguradoras');
        } else if (landing_url.length > 255) {
          errors.push('URL de landing page deve ter no máximo 255 caracteres');
        }
      }

      if (accession_percentage === null || accession_percentage === undefined) {
        errors.push('Percentual de adesão é obrigatório para franquias e seguradoras');
      } else if (accession_percentage < 0 || accession_percentage > 100) {
        errors.push('Percentual de adesão deve estar entre 0 e 100');
      }

      if (signature_percentage === null || signature_percentage === undefined) {
        errors.push('Percentual de assinatura é obrigatório para franquias e seguradoras');
      } else if (signature_percentage < 0 || signature_percentage > 100) {
        errors.push('Percentual de assinatura deve estar entre 0 e 100');
      }

      if (income_value === null || income_value === undefined) {
        errors.push('Receita é obrigatória para franquias e seguradoras');
      } else if (income_value < 0) {
        errors.push('Receita deve ser maior ou igual a zero');
      }
    }

    return errors;
  }

  toParams(attrs = {}) {
    const {
      country,
      name,
      email,
      phone,
      cnpj,
      street,
      district,
      number,
      postal_code,
      contact_name,
      contact_phone,
      contract_expires_at,
      is_driving,
      is_doctor,
      is_doctor_all,
      is_emergency,
      users_limit,
      is_plan,
      disabled_at,
      frozen_at,
      owners,
      specialties,
      packs,
      config_corporation,
      corporation_doctors,
    } = this.toObject();

    let ownersIds = [];
    if (owners) ownersIds = owners.map((item) => item.id);

    let specialtiesIds = [];
    if (specialties && is_doctor_all)
      specialtiesIds = specialties.map((item) => item.id);

    let packsIds = [];
    if (packs) packsIds = packs.map((item) => item.id);

    return {
      data: {
        attributes: {
          country,
          name,
          email,
          phone,
          cnpj,
          city_id: dig(this.get('city'), 'id'),
          corporation_id: dig(this.get('corporation'), 'id'),
          street,
          district,
          number,
          postal_code,
          contact_name,
          contact_phone,
          contract_expires_at,
          is_driving,
          is_doctor,
          is_doctor_all,
          is_plan,
          is_emergency,
          users_limit,
          disabled_at,
          frozen_at,
          owners: ownersIds,
          specialties: specialtiesIds,
          packs: packsIds,
          config_corporation,
          corporation_doctors: (corporation_doctors || []).map((link) => ({
            specialty_id: link.specialty_id,
            doctor_id: link.doctor_id,
            is_exclusive: !!link.is_exclusive,
          })),
          ...attrs,
        },
      },
    };
  }
}
